import { Controller } from "@hotwired/stimulus";

// Hides alert/error banners when any input inside the form changes.
// Usage: add data-controller="dismiss-on-input" and
//        data-action="input->dismiss-on-input#dismiss change->dismiss-on-input#dismiss"
//        to the <form> element.
//        Mark dismissable banners with data-dismiss-on-input-target="banner".
export default class extends Controller {
  static targets = ["banner"];

  dismiss() {
    this.bannerTargets.forEach((el) => {
      el.remove();
    });
  }
}
